// Tiptap's shortcut format is `Mod-Shift-B`, `Mod-Alt-1`, etc. `Mod` resolves to ⌘ on
// Mac and Ctrl elsewhere. This util renders those for display in tooltips.

const MAC_KEYS: Record<string, string> = {
  Mod: '⌘',
  Shift: '⇧',
  Alt: '⌥',
  Ctrl: '⌃',
};

const PC_KEYS: Record<string, string> = {
  Mod: 'Ctrl',
  Shift: 'Shift',
  Alt: 'Alt',
  Ctrl: 'Ctrl',
};

export const isMacPlatform = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /Mac|iPhone|iPad|iPod/.test(navigator.platform);
};

export const formatShortcut = (shortcut: string, isMac: boolean = isMacPlatform()): string => {
  const keys = isMac ? MAC_KEYS : PC_KEYS;
  const separator = isMac ? '' : '+';
  return shortcut
    .split('-')
    .map((key) => keys[key] ?? key.toUpperCase())
    .join(separator);
};
